const userList = () => import('@/pages/user/list/index.vue');
const userDetail = () => import('@/pages/user/list/detail.vue');

export default [{
    path: '/user/list',
    component: userList,
    meta: [{
        name: '用户管理'
    },
    {
        name: '用户列表',
        activeRoute: '/user/list'
    }]
}, {
    path: '/user/detail',
    component: userDetail,
    meta: [{
        name: '用户管理'
    },
    {
        name: '用户列表',
        url: '/user/list'
    },
    {
        name: '用户详情',
        activeRoute: '/user/list'
    }]
}];